import { render, staticRenderFns } from "./anunt-8.vue?vue&type=template&id=bc678942&scoped=true"
import script from "./anunt-8.vue?vue&type=script&lang=js"
export * from "./anunt-8.vue?vue&type=script&lang=js"
import style0 from "./anunt-8.vue?vue&type=style&index=0&id=bc678942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc678942",
  null
  
)

export default component.exports